<template>
  <b-modal
    hide-footer
    size="md"
    title="Admin Block"
    centered
    id="admin-block-modal"
    @hide="hideModal"
  >
    <div class="text-center">
      <h3 class="font-weight-bold text-black">ADMIN BLOCK</h3>
    </div>

    <p class="text-center text-black font-weight-bold">Admin Block</p>

    <b-form-group label="Comment" class="text-black">
      <b-form-textarea
        v-model="form.comments"
        placeholder="Comments"
        rows="4"
      ></b-form-textarea>
    </b-form-group>

    <div class="d-flex items-center" style="gap: 12px">
       <b-button class="w-100" @click="hideModal">
        CANCEL
      </b-button>
      <b-button
        :disabled="loadingClientProfile"
        @click="handleAdminBlock"
        class="w-100"
        variant="danger"
      >
        <Spinner v-if="loadingClientProfile" />
        <template v-else> APPLY ADMIN BLOCK </template>
      </b-button>

     
    </div>
  </b-modal>
</template>

<script>
import Spinner from "@/@core/components/Spinner.vue";
import useToastHandler from "@/services/toastHandler";
import { BModal, BFormGroup, BFormTextarea, BButton } from "bootstrap-vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BModal,
    BFormGroup,
    BFormTextarea,
    BButton,
    Spinner,
  },
  data() {
    return {
      form: { comments: "" },
    };
  },
  computed: {
    ...mapState("user/detail", ["loadingClientProfile"]),
  },
  methods: {
    ...mapActions({
      updateClientProfile: "user/detail/updateClientProfile",
      fetchUser: "user/detail/asyncUser",
    }),
    async handleAdminBlock() {
      const result = await this.updateClientProfile({
        userId: this.$route.params.id,
        isBlocked: 1,
        reasonUpdate: this.form.comments,
      });
      if (result) {
        this.showToastSuccess("Blocked Account successfully!");
        this.$bvModal.hide("admin-block-modal");
        this.fetchUser({ id: this.$router.currentRoute.params.id });
      }
    },
    hideModal() {
      this.form.comments = "";
      this.$bvModal.hide('admin-block-modal')
    },
  },
  setup() {
    const { showToastSuccess, showToastError } = useToastHandler();

    return {
      showToastSuccess,
      showToastError,
    };
  },
};
</script>
